import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { slide } from "./_slide";

document.addEventListener("DOMContentLoaded", () => {
  accordion();
  animation();
  common();
  drawer();
  slide();
});
